import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { Card } from "antd";

export const ManagementType = ({ data }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const processedData = processData(data);
    setChartData(processedData);
  }, [data]);

  const processData = (data) => {
    let salesByManagementtype = {};
    data?.forEach((order) => {
      if (!salesByManagementtype[order.managementtype]) {
        salesByManagementtype[order.managementtype] = {
          totalSales: 0,
          totalItems: 0,
          totalOrders: 0,
        };
      }
      order.products?.forEach((item) => {
        salesByManagementtype[order.managementtype].totalItems += item.quantity;
      });
      salesByManagementtype[order.managementtype].totalSales +=
        order.saleAmount;

      salesByManagementtype[order.managementtype].totalOrders++;
    });

    const chartData = Object.keys(salesByManagementtype)?.map(
      (managementtype) => {
        const managementtypeData = salesByManagementtype[managementtype];
        return {
          managementtype,
          totalSales: managementtypeData.totalSales,
          totalItems: managementtypeData.totalItems,
          totalOrders: managementtypeData.totalOrders,
          averageTicket:
            managementtypeData.totalItems / managementtypeData.totalOrders,
        };
      }
    );

    const sortedChartData = chartData?.sort((a, b) => b.totalOrders - a.totalOrders);
    return sortedChartData;
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const { totalSales, totalItems, totalOrders, averageTicket } =
        payload[0].payload;

      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
          }}
        >
          <b className="intro">{label}</b>
          <p className="intro">{`Ventas totales: S/ ${totalSales?.toFixed(
            2
          )}`}</p>
          <p className="desc">{`Cantidad de órdenes: ${totalOrders}`}</p>
          <p className="desc">{`Cantidad de productos: ${totalItems}`}</p>
          <p className="desc">{`Ticket promedio: ${averageTicket?.toFixed(
            2
          )}`}</p>
        </div>
      );
    }

    return null;
  };

  const renderCustomizedLabel = (props) => {
    const { x, y, width, value } = props;

    return (
      <text
        x={x + width + 5}
        y={y + 25}
        fill="#000"
        textAnchor="start"
        dominantBaseline="start"
        style={{ fontSize: "14px" }}
      >
        {value}
      </text>
    );
  };

  return (
    <Card title="Gestión">
      <ResponsiveContainer width="100%" height={342}>
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{
            left: 20,
            right: 50,
            top: 10,
            bottom: 10,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.5} />
          <XAxis type="number" />
          <YAxis
            dataKey="managementtype"
            type="category"
            tick={{ fontSize: "14px", width: 100 }}
            interval={0}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="totalOrders" fill="#2B767E">
            <LabelList dataKey="totalOrders" content={renderCustomizedLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
